import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  credentials: null,
  user: null,
  role: "",
  originalRole: "",
  email: "",
  loginTime: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setCredentials: (state, action) => {
      state.credentials = action.payload;
    },
    setAuthToken: (state, action) => {
      const token = action.payload;
      state.token = token;
      state.loginTime = Date.now(); 
    },
    logOut: (state) => {
      state.token = "";
      state.role = "";
      state.originalRole = "";
    },
    setRoleAction: (state, action) => {
      state.role = action.payload;
    },
    setOriginalRoleAction: (state, action) => {
      state.originalRole = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
  },
});

export const {
  setAuthToken,
  setCredentials,
  setUser,
  logOut,
  setRoleAction,
  setOriginalRoleAction,
  setEmail,
} = authSlice.actions;

export default authSlice.reducer;
